import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setOffSeasonEvent,
  setSelectedEvent,
  setSelectedSeason,
  setVideoList,
} from "../../../Redux/Actions/PastSeasonActions";
import PastSeasonColumnContainer from "./PastSeasonColumnContainer";

const SeasonList = ({ active, setActive, setActiveEventType }) => {
  const dispatch = useDispatch();
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.userProfile?.currentSeason?.years
  );
  const fetchedSeasonData = useSelector((state) =>
    state.videoLibraryData.fetchedSeasonData?.allSeasonData.filter(
      (data) => data.seasonName !== currentSeason
    )
  );

  useEffect(() => {
    setOffSeasonEvent(dispatch, null);
    setSelectedSeason(dispatch, null);
    setSelectedEvent(dispatch, null);
    setVideoList(dispatch, null);
  }, []);

  const handleSeasonClick = (el) => {
    if (active?.seasonName === el.seasonName) {
      setActive(null);
      setSelectedSeason(dispatch, null);
    } else {
      setSelectedSeason(dispatch, el);
      setActive(el);
    }
    setActiveEventType(null);
    setOffSeasonEvent(dispatch, null);
    setSelectedEvent(dispatch, null);
    setVideoList(dispatch, null);
  };
  return (
    <PastSeasonColumnContainer
      heading={"Seasons"}
      data={fetchedSeasonData}
      handleClick={handleSeasonClick}
      active={active}
      fieldToShow={"seasonName"}
    />
  );
};

export default SeasonList;
